import React from 'react';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import styles from './TableList.module.scss';
import { TransactionFlowListFields as tf } from '../../types';


class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '交易时间',
            dataIndex: tf.transactionTime,
            key: tf.transactionTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '账户外部编号',
            dataIndex: tf.accountOutNo,
            key: tf.accountOutNo,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '账户名称',
            dataIndex: tf.accountName,
            key: tf.accountName,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '交易名称',
            dataIndex: tf.transactionName,
            key: tf.transactionName,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '收支类型',
            dataIndex: tf.incomeOutType,
            key: tf.incomeOutType,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '交易金额',
            dataIndex: tf.transactionAmount,
            key: tf.transactionAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '交易后余额',
            dataIndex: tf.transactionAfterAmount,
            key: tf.transactionAfterAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '清算日期',
            dataIndex: tf.settleTime,
            key: tf.settleTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '对方账号',
            dataIndex: tf.toAccount,
            key: tf.toAccount,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '对方账户名',
            dataIndex: tf.toAccountName,
            key: tf.toAccountName,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '对方账户外部编号',
            dataIndex: tf.toAccountOutNo,
            key: tf.toAccountOutNo,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '交易备注',
            dataIndex: tf.remark,
            key: tf.remark,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '摘要',
            dataIndex: tf.summary,
            key: tf.summary,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '备用域1',
            dataIndex: tf.spareDomain1,
            key: tf.spareDomain1,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '订单号',
            dataIndex: tf.orderNo,
            key: tf.orderNo,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '商户订单号',
            dataIndex: tf.merchantOrderNo,
            key: tf.merchantOrderNo,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '批次号',
            dataIndex: tf.batchNo,
            key: tf.batchNo,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '渠道商户名称',
            dataIndex: tf.channelMerchantName,
            key: tf.channelMerchantName,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '资金渠道名称',
            dataIndex: tf.moneyChannelName,
            key: tf.moneyChannelName,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '业务类型名称',
            dataIndex: tf.businessTypeName,
            key: tf.businessTypeName,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '业务商户号',
            dataIndex: tf.businessMerchantNo,
            key: tf.businessMerchantNo,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        }
    ]);

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={record => record.id}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;